import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { Table, Button, DatePicker } from "antd";
import Select from "react-select";
import { Link } from "react-router-dom";
import moment from "moment";
import Breadcrumbs from "../../../components/Breadcrumbs";

const DeviceLogs = () => {
  const [deviceLogs, setDeviceLogs] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment()); // Default to current date
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null); // Default to random active device
  const apiUrl = process.env.REACT_APP_API_URL;
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(true);
  const maximizeBtnRef = useRef(null);
  const [isFullScreen, setFullScreen] = useState(false);

  useEffect(() => {
    const handleClick = () => {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen();
        setFullScreen(true);
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen();
          setFullScreen(false);
        }
      }
    };

    const cleanup = () => {
      if (isFullScreen && document.exitFullscreen) {
        document.exitFullscreen();
        setFullScreen(false);
      }
    };

    const maximizeBtn = maximizeBtnRef.current;
    maximizeBtn.addEventListener('click', handleClick);

    return () => {
      maximizeBtn.removeEventListener('click', handleClick);
      cleanup();
    };
  }, [isFullScreen]);

  const fetchDevices = async () => {
    try {
      const response = await axios.get(`${apiUrl}/devices/devicelist`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const activeDevices = response.data.filter(device => device.status === 1);
      setDevices(activeDevices);

      if (activeDevices.length > 0) {
        const randomDevice = activeDevices[Math.floor(Math.random() * activeDevices.length)];
        setSelectedDevice({ value: randomDevice.device_sr_no, label: randomDevice.device_desc });
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching devices:", error);
      setLoading(false);
    }
  };

  const fetchDeviceLogs = async () => {
    if (!selectedDevice) {
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(`${apiUrl}/devicelog/logs`, {
        params: {
          srno: selectedDevice.value,
          received_at: selectedDate.format("YYYY-MM-DD"),
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setDeviceLogs(response.data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching device logs:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDevices();
  }, [apiUrl, token]);

  useEffect(() => {
    if (selectedDevice) {
      fetchDeviceLogs();
    }
  }, [selectedDevice, selectedDate]);

  const handlePrevDate = () => {
    setSelectedDate(prevDate => prevDate.clone().subtract(1, 'days'));
  };

  const handleNextDate = () => {
    setSelectedDate(prevDate => prevDate.clone().add(1, 'days'));
  };

  const handleDeviceChange = (selectedOption) => {
    setSelectedDevice(selectedOption);
  };

  const columns = [
    {
      title: 'Terminal ID',
      dataIndex: 'terminal_id',
      key: 'terminal_id',
      sorter: (a, b) => a.terminal_id.localeCompare(b.terminal_id),
    },
    {
      title: 'Device Enroll ID',
      dataIndex: 'enroll_id',
      key: 'enroll_id',
      sorter: (a, b) => a.enroll_id - b.enroll_id,
    },
    {
      title: 'Emp Code',
      dataIndex: 'empcode',
      key: 'empcode',
      sorter: (a, b) => a.empcode.localeCompare(b.empcode),
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: 'Log Time',
      dataIndex: 'log_time',
      key: 'log_time',
      render: (date) => moment(date).format("MMM DD, YYYY HH:mm:ss"),
      sorter: (a, b) => new Date(a.log_time) - new Date(b.log_time),
    },
    {
      title: 'Mode',
      dataIndex: 'mode',
      key: 'mode',
    },
    {
      title: 'In/Out',
      dataIndex: 'inout',
      key: 'inout',
      render: (inout) => inout === 0 ? 'In' : 'Out',
    },
    {
      title: 'Event',
      dataIndex: 'event',
      key: 'event',
    },
    {
      title: 'Verify Mode',
      dataIndex: 'verifymode',
      key: 'verifymode',
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
        <div className="page-header page-top-icons">
  <div className="row align-items-center">
    <div className="col-md-2">
      <h3 className="page-title">Device Logs</h3>
    </div>
    <div className="col-md-3">
      <Select
        style={{ width: '100%' }}
        placeholder="Select Device"
        value={selectedDevice}
        options={devices.map(device => ({ value: device.device_sr_no, label: device.device_desc }))}
        onChange={handleDeviceChange}
      />
    </div>
    <div className="col-md-4 d-flex align-items-center justify-content-center">
      <Button className="fa fa-chevron-circle-left" onClick={handlePrevDate} />
      <span style={{ margin: '0 10px', fontWeight: 'bold', fontSize: '16px' }}>
        {selectedDate.format('MMMM DD, YYYY')}
      </span>
      <Button className="fa fa-chevron-circle-right" onClick={handleNextDate} />
    </div>
    <div className="col-md-3 d-flex justify-content-end">
      <div className="d-flex title-head">
        <div className="view-icons">
          <Link to="#" className="grid-view btn btn-link" onClick={fetchDeviceLogs}><i className="las la-redo-alt" /></Link>
          <Link to="#" className="list-view btn btn-link" id="collapse-header" ref={maximizeBtnRef}><i className="las la-expand-arrows-alt" /></Link>
        </div>
        <Link to="#" className="btn btn-link"><i className="las la-download" /></Link>
      </div>
    </div>
  </div>
</div>

          <div className="row">
            <div className="col-md-12">
              {loading ? (
                <div id="loader-wrapper_">
                  <div className="loader">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                  </div>
                </div>
              ) : deviceLogs.length > 0 ? (
                <div className="table-responsive">
                  <Table
                    className="table-striped"
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    dataSource={deviceLogs}
                    rowKey={(record) => record.id}
                  />
                </div>
              ) : (
                <div className="no-data-container text-center mt-4">
                  <img 
                    src="https://ui-cdn.digitalocean.com/apps/ui-spaces/static/media/spaces-empty.5e1d7947c43b7e336b14e421d4a86639.svg" 
                    alt="No data available" 
                    style={{ width: '150px', marginBottom: '20px' }}
                  />
                  <h3>No Data Available</h3>
                  <p>There are no logs to display for the selected device and date.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeviceLogs;
